import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import {
  isFirmaSubmitLocked,
  logAutofirmaError,
  releaseFirmaSubmitLock,
} from 'src/app/_helpers/firma-submit.guard';
import { Component, Inject, LOCALE_ID, OnInit, ViewChild } from "@angular/core";
import { formatDate } from "@angular/common";
import { MatLegacyPaginator as MatPaginator } from "@angular/material/legacy-paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { DestinatarioDto } from "../destinatario_model";
import { PdfgenerateJustificanteNotificaService } from "../../_services/pdfgenerateJustificanteNotificaService/pdfgenerate-justificante-notifica.service";
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { Destinatario } from "../../model/notificaresumen";
import { NotificationService } from "../../_services/notification.service";
import { TokenStorageService } from "../../_services/token-storage.service";
import { ServicioGeneral } from "../../_services/servicio-general.service";
import * as CryptoJS from "crypto-js";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ClaveService } from "src/app/_services/clave.service";
import { SamlRequest } from "src/app/model/samltoken";
import { Subscription } from "rxjs";
import { NavService } from "src/app/boton-listado/boton-listado.component.service";
import { ListadoTramitesEmvsService } from "src/app/listado/listado-tramites-emvs/listado-tramites-emvs.service";
import { ClientFirmaLogService } from "src/app/_services/client-firma-log.service";
import { NotificationI18nService } from '../../core/util/notification-i18n.service';
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
declare const AutoScript: any;
declare const Constants: any;

@Component({
  selector: "app-notificaciones-autorizaciones",
  templateUrl: "./notificaciones-autorizaciones.component.html",
  styleUrls: ["./notificaciones-autorizaciones.component.scss"],
})
export class NotificacionesAutorizacionesComponent extends UnsubscribeOnDestroy implements OnInit {
  notificaciones: Destinatario[] | null = null;
  notificacionesDto: DestinatarioDto[] = [];
  displayedColumns: string[] = [
    "Identificador",
    "Entidad",
    "Fecha disposición",
    "Fecha rechazo automático",
    "Tipo",
    "Firma requerida por",
    "Descripción",
  ];
  dataSource = new MatTableDataSource<DestinatarioDto>();
  notificacionActivada: Destinatario;
  loading: boolean = false;
  selectedOpcion: String = "Firmar con Autofirma";
  diasCaducidad: string = localStorage.getItem(
    "notificacionesPendientesMaxDays"
  );
  displayFirma: string = "none";
  firmaResultLocked = false;
  subscription: Subscription;
  notificacionSelected: Destinatario;
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    if (sort) { this.dataSource.sort = sort; }
  }
  @ViewChild(MatPaginator) set matPaginator(paginator: MatPaginator) {
    if (paginator) { this.dataSource.paginator = paginator; }
  }

  get totalAutorizaciones(): number { return this.dataSource?.data?.length || 0; }
  get autorizacionesMostradas(): number { return this.dataSource?.filteredData?.length ?? this.totalAutorizaciones; }

  constructor(
    private pdfJustificante: PdfgenerateJustificanteNotificaService,
    private notificationI18n: NotificationI18nService,
    private _tokenStorageService: TokenStorageService,
    private _servicioGeneral: ServicioGeneral,
    private _router: Router,
    private spinner: NgxSpinnerService,
    private _claveService: ClaveService,
    private _route: ActivatedRoute,
    private _navService: NavService,
    private _download:ListadoTramitesEmvsService,
    private _clientFirmaLog: ClientFirmaLogService,
    @Inject(LOCALE_ID) public locale: string,
  ) {
    super();
  }

  ngOnInit(): void {
    this.misNotificaciones();
    this.subscription = this._navService.navItem$
      .pipe(takeUntil(this.destroy$))
      .subscribe((item) => {
      this.selectedOpcion = item;
    });
  }

  acceptButton(notificacion) {
    this.displayFirma = "block";
    notificacion.aceptar = true;
    this.notificacionActivada = notificacion;
  }
  closeButton() {
    this.displayFirma = "none";
    this.notificacionActivada = null;
  }

  misNotificaciones(): void {
    this._servicioGeneral
      .postNotificaNotificaciones({ estado: "PENDIENTE", tipoEnvio: 3 })
      
        .pipe(takeUntil(this.destroy$))
        .subscribe({
        next: (response) => {
          if (response.respuesta.code == "200") {
            const list = response.envios.autorizaciones ?? [];
            this.notificaciones = list;
            this.notificacionesDto = list.map((item) => ({
              Id: item.envio,
              Identificador: item.identificador,
              Entidad: item.organismo_emisor,
              "Fecha disposición": item.fecha_disposicion
                ? new Date(this.formatoFecha(item.fecha_disposicion))
                : undefined,
              "Fecha rechazo automático": item.fecha_caducidad
                ? new Date(this.formatoFecha(item.fecha_caducidad))
                : undefined,
              Tipo: item.tipo_envio?.nombre ?? "",
              "Firma requerida por": item.concepto ?? "",
              Descripción: item.descripcion ?? "",
              Destinatario: item,
            }));
            this.dataSource.data = this.notificacionesDto;
          } else {
            this.notificationI18n.infoDynamic(response.respuesta, 4000);
            this.notificaciones = [];
            this.notificacionesDto = [];
            this.dataSource.data = [];
          }
        },
        error: (err) => {
          this.notificaciones = [];
          this.notificacionesDto = [];
          this.dataSource.data = [];
          this.notificationI18n.error('NOTIFICATION.MESSAGE.NO_SE_PUDIERON_CARGAR_LAS_AUTORIZACIONES');
        },
      });
  }

  notificacionAcept() {
    this.mostrarSpinnerMsg("Solicitando firma");
    this.loading = true;

    // notificacion.csv = CryptoJS.HmacSHA256(this._tokenStorageService.dataUserForm.numero_documento+notificacion.identificador, 'SHA256').toString().slice(0,39);
    if (this.selectedOpcion == "Firmar con Autofirma") {
      this.signAutoFirma(this.notificacionActivada);
    } else {
      this.firmarClave(this.notificacionActivada.envio);
    }

    //this.singFile(dataB64); //firmar antes de enviar*/
  }
  signAutoFirma(notificacion) {

    this.notificacionActivada = notificacion;
    this._download.downloadB64(notificacion.idNextcloud.id_gestor_documental)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next:(fichero) => {
        if (fichero?.Result) {
          this._clientFirmaLog.iniciada(notificacion.envio, 'notificaciones-autorizaciones');
          this.singFile(fichero.Result);
        } else {
          this.loading = false;
          this.ocultarSpinner();
          this.notificationI18n.error('NOTIFICATION.MESSAGE.NO_HA_SIDO_POSIBLE_RECUPERAR_EL_DOCUMENTO_A_FIRMAR', 5000);
        }
      },
      error: () => {
        this.loading = false;
        this.ocultarSpinner();
        this.notificationI18n.error('NOTIFICATION.MESSAGE.NO_HA_SIDO_POSIBLE_RECUPERAR_EL_DOCUMENTO_A_FIRMAR', 5000);
      }});

  }

  firmarClave(id) {
    let tipo = this.notificacionActivada.aceptar? 2:3;
    this._claveService.iniciaFirma(id,tipo)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: async (data: SamlRequest) => {
        this.post(data.nodeService, {
          SAMLRequest: data.SamlRequest,
          RelayState: data.RelayState,
        });
      },
      error: (error) => console.error(error),
    });
  }


  post(path: string, params: any): void {
    let method = "post";
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }
    }
    document.body.appendChild(form);
    form.submit();
  }

  notificacionReject(notificacion: Destinatario) {
    this.loading = true;
    this._servicioGeneral.getNotificaReject(notificacion.envio)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (response) => {
        if (response.code == "200") {
          var continueTramite = response.canContinueRegister ?? true;
          if(!continueTramite){
            this.notificationI18n.errorDynamic(response, 5000);
          }
          else{
            this.notificationI18n.successDynamic(response, 4000);
          }

          let reload = this._router.url;

          if (reload.includes("?action")) {
            const parts = reload.split("?");
            reload = parts[0];
          }

          reload = reload.concat("?action=35");
          console.log(reload);
          
          this._router
            .navigate(["inicio"], { skipLocationChange: true })
            .then(() => {
              this._router.navigateByUrl(reload);
            });
        } else {
          this.loading = false;
          this.notificationI18n.infoDynamic(response, 4000);
        }
      },
      error: (err) => {
        this.loading = false;
        this.notificationI18n.error('NOTIFICATION.MESSAGE.NO_SE_PUDIERON_CARGAR_LAS_AUTORIZACIONES');
      },
    });
  }

  formatoFecha(date) {
    if (date) {
      let month = date[1] ? (date[1] < 10 ? "0" + date[1] : date[1]) : "";
      let day = date[2] ? (date[2] < 10 ? "0" + date[2] : date[2]) : "";
      let year = date[0];
      let hour = date[3] < 10 ? "0" + date[3] : date[3];
      let min = date[4] < 10 ? "0" + date[4] : date[4];
      let seg = date[5] ? (date[5] < 10 ? "0" + date[5] : date[5]) : "00";
      return [year, month, day].join("-").concat("T" + [hour, min, seg].join(":") + ".000Z");
    }
    return "";
  }

  formatDate(date: Date): string {
    if (!date || isNaN(date.getTime())) {
      return "";
    }
    return formatDate(date, "dd-MM-yyyy HH:mm", this.locale, "GMT");
  }

  public singFile(data): void {
    try {
      AutoScript.cargarAppAfirma();
      AutoScript.setServlets(
        Constants.URL_BASE_SERVICES +
          "/afirma-signature-storage/StorageService",
        Constants.URL_BASE_SERVICES +
          "/afirma-signature-retriever/RetrieveService"
      );
      AutoScript.sign(
        data != undefined && data != null && data != "" ? data : null,
        "SHA256withRSA",
        "AUTO",
        "",
        this.successCallback,
        this.showErrorCallback
      );
    } catch (e) {
      this._clientFirmaLog.noDisponible(this.notificacionActivada?.envio, 'notificaciones-autorizaciones');
      this.notificationI18n.error('NOTIFICATION.MESSAGE.DEBES_DISPONER_DE_LA_APLICACION_AUTOFIRM_PARA_FIRMAR_LOS_TRAMITES_ADMINISTRATIVO');
    }
  }

  public successCallback = (filenameB64, certB64): void => {
    if (isFirmaSubmitLocked(this)) {
      return;
    }
    // filenameB64 es el nombre del fichero de firma codificado en Base 64
    (document.getElementById("certifcado") as HTMLInputElement).value = certB64;
    (document.getElementById("result") as HTMLInputElement).value = filenameB64;
    (document.getElementById("error") as HTMLInputElement).value = "";
    document.forms["firma"].dispatchEvent(
      new Event("submit", { cancelable: true, bubbles: true })
    );
  }
  public showErrorCallback = (errorType, errorMessage): void => {
    logAutofirmaError(this._clientFirmaLog, this.notificacionActivada?.envio, 'notificaciones-autorizaciones', errorType, errorMessage);
    if (isFirmaSubmitLocked(this)) {
      releaseFirmaSubmitLock(this);
      return;
    }
    (document.getElementById("certifcado") as HTMLInputElement).value = "";
    (document.getElementById("result") as HTMLInputElement).value = "";
    (document.getElementById("error") as HTMLInputElement).value = errorMessage;
    this.ocultarSpinner();
    document.forms["firma"].dispatchEvent(
      new Event("submit", { cancelable: true, bubbles: true })
    );
  }

  resultchange(event: Event): void {
    event.preventDefault();
    if (isFirmaSubmitLocked(this)) {
      return;
    }
    this.firmaResultLocked = true;
    this.ocultarSpinner();
    let base64Document = (document.getElementById("result") as HTMLInputElement)
      .value;
    let errorFirma = (document.getElementById("error") as HTMLInputElement)
      .value;

    if (errorFirma == "" && base64Document != "") {
      this.mostrarSpinnerMsg("Firmando y enviando documento...");
      let certificado = atob(
        (document.getElementById("certifcado") as HTMLInputElement).value
      );
      if (
        certificado.includes(
          this._tokenStorageService.getUser().numero_documento
        )
      ) {
        this._clientFirmaLog.exito(this.notificacionActivada?.envio, 'notificaciones-autorizaciones');
        this.sendJustificante(base64Document);

        this.notificationI18n.info('NOTIFICATION.MESSAGE.AUTORIZACION_ACEPTADA_CON_EXITO_PROCESANDO_TRAMITE');
      } else {
        releaseFirmaSubmitLock(this);
        this._clientFirmaLog.certificadoInvalido(this.notificacionActivada?.envio, 'notificaciones-autorizaciones');
        this.loading = false;
        this.notificationI18n.error('NOTIFICATION.MESSAGE.EL_PDF_NO_SE_HA_PODIDO_FIRMAR_EL_CERTIFICADO_NO_COINCIDE_CON_EL_USUARIO');
        this.ocultarSpinner();
      }
    } else {
      releaseFirmaSubmitLock(this);
      this._clientFirmaLog.error(this.notificacionActivada?.envio, 'notificaciones-autorizaciones', undefined, errorFirma || 'Firma cancelada o fallida');
      this.loading = false;
      this.notificationI18n.error('NOTIFICATION.MESSAGE.EL_PDF_NO_SE_HA_PODIDO_FIRMAR_POR_FAVOR_COMPRUEBE_QUE_NO_DISPONE_DE_NINGUN_BLOQU');

    }
  }

  sendJustificante(base64Document) {
    this._servicioGeneral
      .postNotificaJustificante({
        base64: base64Document,
        mimeType: "aplication/pdf",
        nameDocument: `justificante_${this.notificacionActivada.identificador}.pdf`,
        id: this.notificacionActivada.envio,
        csv: this.notificacionActivada.csv,
      })
      
        .pipe(takeUntil(this.destroy$))
        .subscribe({
        next: (value) => {
          var continueTramite = value.canContinueRegister ?? true;
          if(!continueTramite){
            this.notificationI18n.error(
              "Error",
              value.message??"No es posible firmar esta solicitud, su DNI/NIF existe en otro registro, si quiere seguir con este trámite solicite baja por Instancia General en la oficina virtual",
              5000
            );
          }
          releaseFirmaSubmitLock(this);
          this.loading = false;
          let reload = this._router.url;

          if (reload.includes("?action")) {
            const parts = reload.split("?");
            reload = parts[0];
          }

          reload = reload.concat("?action=33");

          this._router
            .navigate(["inicio"], { skipLocationChange: true })
            .then(() => {
              this._router.navigateByUrl(reload);
            });
          this.ocultarSpinner();
        },
        error: (err) => {
          console.error(err);
          releaseFirmaSubmitLock(this);
          this.loading = false;
          this.notificationI18n.error('NOTIFICATION.MESSAGE.EL_PDF_NO_SE_HA_PODIDO_SUBIR');
          this.ocultarSpinner();
        },
      });
  }
  //Apartado SPINNER
  mensajeSpinner: string = "";
  mostrarSpinnerMsg(mensaje: string) {
    this.mensajeSpinner = mensaje;
    this.spinner.show('notificaciones_autorizaciones_spinner');
   /* setTimeout(() => {
     
      this.spinner.hide();
    }, 60000);*/
  }
  ocultarSpinner() {
    this.spinner.hide('notificaciones_autorizaciones_spinner');
  }
}
